<template>
  <div class="hello">
    <p>I'm a Computer Engineer from Vancouver, BC.</p>
    <p>I'm currently working with the Data Infrastructure Team at <a href=https://www.shopify.com>Shopify</a> in Ottawa.</p>
    <p>My interests include <b>Big Data</b>, <b>Distributed Computing</b> and <b>Machine Learning.</b></p>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {

}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
p {
}
</style>
